<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <tipo-emolumento />
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento dos Emolumentos.</span>
                <br />
                <span class="navigation">Cadastros > Emolumento</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">

            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Código:</label>
                <span class="p-fluid">
                  <InputText type="text" id="codigo" maxlength="10" v-model="Emolumento.codigo"
                    :class="{ 'p-error': validationErrors.codigo }" />
                </span>
                <small v-show="validationErrors.codigo" class="p-error">Código é Obrigatório.</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" maxlength="500" v-model="Emolumento.nome"
                    :class="{ 'p-error': validationErrors.nome }" />
                </span>
                <small v-show="validationErrors.nome" class="p-error">Nome é Obrigatório.</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mb-2">
                <label for="tipoTomador">Descrição: </label>
                <span class="p-fluid">
                  <textarea v-model="Emolumento.descricao" rows="5" maxlength="500" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 mb-2">
                <label for="origem">Origem: *</label>
                <span class="p-fluid">
                  <AutoComplete id="origem" v-model="selectedOrigem" :dropdown="true" :suggestions="filteredOrigem"
                    @complete="searchOrigens($event)" field="nome" placeholder="Pesquisar"
                    :class="{ 'p-error': validationErrors.origem }" />
                </span>
                <small v-show="validationErrors.origem" class="p-error">Origem é Obrigatória.</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 mb-2">
                <label for="tipo">Tipo: *</label>
                <span class="p-fluid">
                  <AutoComplete id="tipo" v-model="selectedTipo" :dropdown="true" :suggestions="filteredTipo"
                    @complete="searchTipos($event)" field="nome" placeholder="Pesquisar"
                    :class="{ 'p-error': validationErrors.tipo }" />
                </span>
                <small v-show="validationErrors.tipo" class="p-error">Tipo é Obrigatório.</small>
              </div>
              <div class="col-md-1 mb-2">
                <span class="p-fluid ml-2">
                  <div class="p-inputgroup" style="padding-top: 6px;">
                    <Button @click="editarTipo()" id="btnEditarTipo" type="button" icon="pi pi-pencil"
                      title="Gerenciar Tipo Emolumento" />
                  </div>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="nome">Possui Desconto?</label>
                <span class="p-fluid">
                  <Dropdown id="selectedPossuiDesconto" v-model="selectedPossuiDesconto" :options="opcoes"
                    optionLabel="name" placeholder="Selecione uma opção" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="vlrBruto">Valor Bruto: *</label>
                <span class="p-fluid">
                  <money id="vlrBruto" name="vlrBruto" v-model="Emolumento.valorBruto" v-bind="money"
                    class="p-inputtext input-right"></money>
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="vlrFunCompen">Valor Fundo Compensação: *</label>
                <span class="p-fluid">
                  <money id="vlrFunCompen" name="vlrFunCompen" v-model="Emolumento.valorFundoCompensacao" v-bind="money"
                    class="p-inputtext input-right"></money>
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="valor">Valor: *</label>
                <span class="p-fluid">
                  <money id="valor" name="valor" v-model="Emolumento.valor" v-bind="money"
                    class="p-inputtext input-right"></money>
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="taxa">Taxa Fiscalização: *</label>
                <span class="p-fluid">
                  <money id="taxa" name="taxa" v-model="Emolumento.taxaFiscalizacao" v-bind="money"
                    class="p-inputtext input-right"></money>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mb-2">
                <label for="tipoTomador">Descrição dos Repasses: </label>
                <span class="p-fluid">
                  <textarea v-model="Emolumento.descricaoRepasses" rows="5" maxlength="500" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label>Data Vigencia Inicial:</label>
                <span class="p-fluid">
                  <Calendar id="dataInicial" name="dataInicial" disabled="true" :showIcon="true"
                    v-model="Emolumento.dataVigenciaInicial" dateFormat="dd/mm/yy" />
                </span>
              </div>

              <div class="col-md-2 mb-2">
                <label>Data Vigencia Final:</label>
                <span class="p-fluid">
                  <Calendar id="dataFinal" name="dataFinal" disabled="true" v-model="Emolumento.dataVigenciaFinal" :showIcon="true"
                    dateFormat="dd/mm/yy" />
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check" :disabled="loading">
              </Button>
              <router-link to="/emolumentos">
                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                  icon="pi pi-arrow-left" :disabled="loading"></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import Emolumento from "../models/nfse/Emolumento";
import cartorioService from '../services/nfse/cartorio.service';
import TipoEmolumento from "../components/cartorio/TipoEmolumento";

export default {
  name: "EmolumentoCadastro",
  components: {
    TipoEmolumento
  },
  data() {
    return {
      money: money,
      currentUser: null,
      loading: false,
      selectedTipo: null,
      selectedOrigem: null,
      selectedPossuiDesconto: null,
      filteredTipo: null,
      filteredOrigem: null,
      Emolumento: new Emolumento(),
      validationErrors: {},
      opcoes: [{ name: "Sim", key: "S" }, { name: "Não", key: "N" }],
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.EmolumentoId = this.$route.params.id;

    if (this.EmolumentoId != null) {
      setTimeout(async () => {
        await cartorioService.getEmolumento(this.EmolumentoId).then(
          response => {

            this.Emolumento = response.data;
            this.selectedTipo = response.data.idTipo;
            this.selectedOrigem = response.data.idOrigem;
            this.selectedPossuiDesconto = this.opcoes.filter(
              local => local.key == response.data.idBolPossuiDesconto
            )[0];
          },
          error => {
            let errorMessage = "Houve um problema ao buscar o Emolumento!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
      }, 250);
    }
  },
  methods: {
    validateForm() {
      if (!this.Emolumento.codigo)
        this.validationErrors['codigo'] = true;
      else
        delete this.validationErrors['codigo'];

      if (!this.Emolumento.nome)
        this.validationErrors['nome'] = true;
      else
        delete this.validationErrors['nome'];

      if (!this.selectedOrigem || !this.selectedOrigem.id)
        this.validationErrors['origem'] = true;
      else
        delete this.validationErrors['origem'];

      if (!this.selectedTipo || !this.selectedTipo.id)
        this.validationErrors['tipo'] = true;
      else
        delete this.validationErrors['tipo'];

      return !Object.keys(this.validationErrors).length;
    },
    onSubmit() {
      this.loading = true;

      if (this.validateForm()) {
        this.salvar();
      }

      this.loading = false;
    },
    searchTipos(event) {
      setTimeout(async () => {
        this.filteredTipo = await cartorioService.findAllTipoByFiltro(this.currentUser.usuario.idCliente, event.query);
      }, 250);
    },
    searchOrigens(event) {
      setTimeout(async () => {
        this.filteredOrigem = await cartorioService.findAllOrigemByFiltro(event.query);
      }, 250);
    },
    salvar() {
      this.Emolumento.idCliente = this.currentUser.usuario.idCliente;
      this.Emolumento.idTipo = this.selectedTipo;
      this.Emolumento.idOrigem = this.selectedOrigem;
      this.Emolumento.idBolPossuiDesconto = this
        .selectedPossuiDesconto
        ? this.selectedPossuiDesconto.key
        : null;
      cartorioService.save(this.Emolumento).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Emolumento salvo com sucesso"
          });
          this.$router.push("emolumentos");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar o Emolumento!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    editarTipo() {
      this.$root.$emit("emolumento:novoTipo", this.currentUser.usuario.idCliente);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 3px;
}
</style>